import { combineReducers } from "redux";
import errorReducer from "./errorReducer";
import airtableDynamicTableReducer from "./airtableDynamicTableReducer";
import loginReducer from "./loginReducer";
import nbfcLoginReducer from "./nbfcLoginReducer";
import otpReducer from "./otpReducer";
import auctionInvReducer from "./auctionInvReducer";
import allAuctionListReducer from "./allAuctionListReducer";
import submitBidReducer from "./submitBidReducer";
import fetchFeatureSettingReducer from "./fetchFeatureSettingReducer";
import createAuctionReducer from "./createAuctionReducer";
import fetchAuctionUploadedListReducer from "./fetchAuctionUploadedListReducer";
import fetchAuctionUploadedInvListReducer from "./fetchAuctionUploadedInvListReducer";
import submitUpdateBidStatusReducer from "./submitUpdateBidStatusReducer";
import fetchBidStatusReducer from "./fetchBidStatusReducer";

import { persistReducer } from "redux-persist";
import  storage  from "redux-persist/lib/storage";


const persistConfig = {
  key: "root",
  storage: storage,
  blacklist: [
  ]
}

const rootReducer = combineReducers({
  errorReducer,
  airtableDynamicTableReducer,
  loginReducer,
  nbfcLoginReducer,
  otpReducer,
  auctionInvReducer,
  allAuctionListReducer,
  submitBidReducer,
  fetchFeatureSettingReducer,
  createAuctionReducer,
  fetchAuctionUploadedListReducer,
  fetchAuctionUploadedInvListReducer,
  submitUpdateBidStatusReducer,
  fetchBidStatusReducer
});

export default  persistReducer(persistConfig, rootReducer);